import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import TicketHeaderAssigneeButton from 'flow/components/tickets/TicketHeader/StateAndAssigneeButtons/TicketHeaderAssigneeButton';
import TicketHeaderStateButton from 'flow/components/tickets/TicketHeader/StateAndAssigneeButtons/TicketHeaderStateButton';
import TicketHeaderPhoneButton from './TicketHeaderPhoneButton';

interface Props {
    ticketKey: TicketKey;
}

const TicketHeaderActions = ({ ticketKey }: Props) => (
    <div className="flex shrink-0 items-center gap-x-2">
        <TicketHeaderPhoneButton ticketKey={ticketKey} />
        <TicketHeaderAssigneeButton ticketKey={ticketKey} />
        <TicketHeaderStateButton ticketKey={ticketKey} />
    </div>
);

export default React.memo(TicketHeaderActions);
